import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'

export default class GanttControls extends Component {
	canZoom = direction => {
		const {
			zoomLevelIndex,
			zoomLevels
		} = this.props

		switch(direction){
			case 'up':
				return zoomLevelIndex < (zoomLevels.length - 1)
			case 'down':
				return zoomLevelIndex > 0
		}

		return false
	}

	render() {
		const {
			setZoom,
		} = this.props

		const buttonProps = [
			{
				size: 'big',
				level: 'low',
				label: 'Fit to screen',
				callback: _ => {
					setZoom('fit')
				},
				icon: 'expand'
			}
		]

		return (
			<div className="gantt-controls">
				<div className="zoom-controls">
					<button
						onClick={_ => {setZoom('down')}}
						disabled={!this.canZoom('down')}
					>
						<Icon name="fe-minus" />
                	</button>
					<span>
						Zoom
                	</span>
					<button
						onClick={_ => {setZoom('up')}}
						disabled={!this.canZoom('up')}
					>
						<Icon name="fe-plus" />
                	</button>
				</div>
				<ul className="button-shelf">
					{ buttonProps.map((button, index) => {
						return (
							<li key={index}>
								<Button {...button} />
							</li>
						)
					}) }
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/gantt/gantt-controls.jsx